// extracted by mini-css-extract-plugin
export var checkbox = "q_X";
export var checkboxEl = "q_Y";
export var modalCloseButton = "q_0";
export var svg = "q_Z";